import { render, staticRenderFns } from "./RatingForm.vue?vue&type=template&id=442b7d34"
import script from "./RatingForm.vue?vue&type=script&lang=ts"
export * from "./RatingForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports